import { get, post } from '../utils/axios'

//main saperate by status
export const getContractAPI = async (param) => {
  return await get('contract', param)
}

//contract detail
export const getContractDetailAPI = async (body) => {
  return await get('contract/detail', body)
}

//contract file detail
export const getContractDetailFileAPI = async (body) => {
  return await get('contract/detail/file', body)
}

//SALARY
export const updateSalaryAPI = async (param) => {
  return await post('contract/salary', param)
}
//SECRET
export const updateSecretAPI = async (param) => {
  return await post('contract/secret', param)
}
//EMPLOY
export const updateEmployAPI = async (param) => {
  return await post('contract/employ', param)
}
//PDPA
export const updatePDPAAPI = async (param) => {
  return await post('contract/pdpa', param)
}

//yeaer
export const getTypeYearAPI = async () => {
  return await get('types/years')
}

//status
export const getStatusAPI = async () => {
  return await get('contract/status')
}
